export default __webpack_public_path__ + "static/media/danawa-logo.abedb036.jpg";